import AuthLayout from '@/layouts/AuthLayout.vue';

const externalRouters = {
    path: '/auth',
    component: AuthLayout,
    children: [
        {
            path: '/login',
            name: 'LoginPage',
            component: () => import('../pages/LoginPage.vue'),
            meta: {
                onlyWhenLoggedOut: true,
                isLogo: true,
            },
        },
        {
            path: '/register',
            name: 'RegisterPage',
            component: () => import('../pages/RegisterPage.vue'),
            meta: {
                isLogo: true,
            },
        },
        {
            path: '/otp',
            name: 'OtpPage',
            component: () => import('../pages/OtpPage.vue'),
            meta: {
                isLogo: true,
            },
        },
        {
            path: '/forgot-password',
            name: 'ForgotPasswordPage',
            component: () => import('../pages/ForgotPasswordPage.vue'),
            meta: {
                isLogo: true,
            },
        },
        {
            path: '/user/reset-password',
            name: 'ResetPasswordPage',
            component: () => import('../pages/ResetPasswordPage.vue'),
            meta: {
                isLogo: true,
            },
        },
        {
            path: '/verification',
            name: 'VerificationPage',
            component: () => import('../pages/VerificationPage.vue'),
            meta: {
                requiresAuth: true,
                isLogo: false,
            },
        },
    ],
};

export const authRouters = [externalRouters];
